import {useSession} from "./useSession";
import {useConfig} from "./useConfig";
import {getShortName, roleValue2Display} from "../utils/helpers";
import {ROLES} from "../utils/constants";

export const useCSMAccessCheck = () => {
    let config = useConfig();
    const {getSession} = useSession();
    const cachedSession = getSession();

    const isCSMSystem = () => {
        let shortName = getShortName();
        if (!shortName) {
            return false;
        }
        return shortName.toLowerCase() === config.csm_short_name.toLowerCase();
    }

    const isCSMAdmin = () => {
        const {isCSMAdmin=false} = cachedSession;
        return isCSMAdmin;
    }

    const checkIsCSMAdmin = (role, email) => {
        email = !!email ? email.toLowerCase() : "";
        role = !!role ? role.toLowerCase() : "";
        const {MGMTSettings={}} = cachedSession;
        const {rootAdminRoles="", rootAdminEmails=""} = MGMTSettings;
        if(rootAdminRoles.indexOf(role) >= 0 || rootAdminEmails.toLowerCase().indexOf(email) >= 0) {
            return true;
        }

        if (!role) {
            return false;
        }

        return role
            .replace(/[\[\]"]/g, "") // Remove brackets and quotes
            .split(",")              // Split into an array
            .map(r => r.trim().toLowerCase()) // Trim and lowercase
            .filter(r => r !== "")   // Remove empty strings
            .some(r => rootAdminRoles.includes(r));
    }

    const checkIsAdminUser = (role, email) => {
        const {MGMTSettings={}} = cachedSession;

        const {nonRootAdminRoles="", nonRootAdminEmails=""} = MGMTSettings;
        return nonRootAdminRoles.indexOf(role) >= 0 || nonRootAdminEmails.indexOf(email) >= 0
    }

    const checkIsFromCSM = () => {
        const {isFromCSM=false} = cachedSession;
        return isFromCSM;
    }

    const checkInstAccess = (inst) => {
        // if (isCSMAdmin()) {
        //     return true;
        // }

        const {userId=""} = cachedSession;
        // let {adminManagers="[]"} = inst;
        let adminManagers = !!inst.adminManagers ? JSON.parse(inst.adminManagers) : [];
        let managerObj = adminManagers.find(i => i.id === userId);
        if (!managerObj) {
            return false;
        }

        let {accessStartDate="", accessEndDate=""} = managerObj;
        let now = Date.now();
        const startDateEpochTime = !!accessStartDate ? new Date(`${accessStartDate}T00:00:00`).getTime() : null;
        const endDateEpochTime = !!accessEndDate ? new Date(`${accessEndDate}T23:59:59`).getTime() : null;
        if (!startDateEpochTime || !endDateEpochTime) {
            return true;
        }
        return now >= startDateEpochTime && now <= endDateEpochTime;
    }

    const getAccessLevel = (inst) => {
        const {userId=""} = cachedSession;
        let adminManagers = !!inst.adminManagers ? JSON.parse(inst.adminManagers) : [];
        let managerObj = adminManagers.find(i => i.id === userId);
        if (!managerObj || !managerObj.role) {
            return roleValue2Display(ROLES.IT_MANAGER.value);
        }

        return roleValue2Display(managerObj.role);

    }


    return {
        isCSMSystem,
        isCSMAdmin,
        checkInstAccess,
        checkIsCSMAdmin,
        checkIsAdminUser,
        getAccessLevel,
        checkIsFromCSM
    };
}